import './OrdersTable.scss'

import { Button, message, Spin } from 'antd'
import { AppRoutes } from 'App'
import { getFormattedPrice } from 'helpers/Formatting'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { useSiparislerimQuery } from '../../gql/GeneratedGraphqlTypes'
import useMediaQuery from '../../hooks/useMediaQuery'
import { ReactComponent as IptalIcon } from '../../images/status-icons/iptalTalep.svg'
import EmptyOrder from '../empty-order/EmptyOrder'
import { ReactComponent as DownIcon } from './image/Down.svg'
import { ReactComponent as HazirlaniyorIcon } from './image/hazirlaniyor.svg'
import { ReactComponent as KargolandiIcon } from './image/kargolandi.svg'
import { ReactComponent as OnaylandiIcon } from './image/onaylandi.svg'
import { OrderItem } from './types'

const OrderTable = () => {
  const [messageApi, contextHolder] = message.useMessage()
  const isMobile = useMediaQuery(768)
  const navigate = useNavigate()
  const { data, error, loading } = useSiparislerimQuery({
    // <-- loading eklendi
    variables: { page: 0 },
  })

  if (error) {
    messageApi.error(`${error}`, 2)
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
        <Spin size="large" tip="Siparişler yükleniyor..." />
      </div>
    )
  }

  if (!data) {
    return null
  }

  if (!data || !data.siparislerim || data.siparislerim.length === 0) {
    // Eğer "data" yoksa veya "siparislerim" dizisi boşsa, tabloyu göstermeyin.
    return (
      <>
        <EmptyOrder />
      </>
    )
  }
  const handleButtonClick1 = (record: OrderItem) => {
    navigate(`/${AppRoutes.account.root}/${AppRoutes.account.orderDetail}/${record.siparis_no}/`)
  }

  const handleButtonClick2 = (record: OrderItem) => {
    navigate(`/${AppRoutes.account.root}/${AppRoutes.account.orderDetailCheck}/${record.key}/`)
  }

  const OrderItems: OrderItem[] = data.siparislerim.map((urun) => {
    const siparisTarihi = urun?.tarih ? new Date(urun.tarih).toISOString().slice(0, 10) : ''
    return {
      key: urun?.id?.toString() || '',
      siparis_tarihi: siparisTarihi,
      siparis_no: Number(urun?.id),
      tutar: Number(urun?.toplam_tutar) || 0,
      durum: urun?.durum || '',
    }
  })

  const renderIcon = (status: string) => {
    switch (status) {
      case 'Hazırlanıyor':
        return <HazirlaniyorIcon className="status-icon" />
      case 'Kargolandı':
      case 'Kısmi Kargolandı':
        return <KargolandiIcon className="status-icon" />
      case 'Tamamlandı':
      case 'Teslim Edildi':
        return <OnaylandiIcon className="status-icon" />
      case 'İptal':
        return <IptalIcon className="status-icon" />
      default:
        return null
    }
  }
  return (
    <>
      {contextHolder}
      <div className="orders-table">
        <h2>Siparişlerim</h2>
        {isMobile ? (
          <div className="mobile-orders-table">
            {OrderItems.map((order) => (
              <div key={order.key} className="mobile-order-item">
                <div className="mobile-order-header">
                  <span>{order.siparis_tarihi}</span>
                  <span>#{order.siparis_no}</span>
                  <span className="mobile-order-status">{order.durum}</span>
                  <span className="mobile-order-total">{getFormattedPrice(order.tutar.toString())} TL</span>
                </div>
                <div className="mobile-order-actions">
                  <Button type="primary" onClick={() => handleButtonClick1(order)}>
                    Ürünler
                  </Button>
                  <Button type="primary" onClick={() => handleButtonClick2(order)}>
                    Adres ve Ödeme
                  </Button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="orders-container">
            <div className="orders-header">
              <span className="header-date">Sipariş Tarihi</span>
              <span className="header-number">Sipariş No</span>
              <span className="header-status">Durum</span>
              <span className="header-total">Toplam Tutar</span>
              <span className="header-actions">Detay</span>
            </div>
            {OrderItems.map((order) => (
              <div key={order.key} className="order-item">
                <span className="order-date">{order.siparis_tarihi}</span>
                <span className="order-number">#{order.siparis_no}</span>
                <span className={`order-status ${order.durum.toLowerCase()}`}>
                  {' '}
                  {renderIcon(order.durum)} {order.durum}
                </span>
                <div className="order-total"> {getFormattedPrice(order.tutar.toString())} TL</div>
                <div className="order-actions">
                  <div className="action-button-tab" onClick={() => handleButtonClick1(order)}>
                    Siparişinize Ait Ürünler
                    <DownIcon />
                  </div>
                  <div className="action-button-tab" onClick={() => handleButtonClick2(order)}>
                    Adres ve Ödeme
                    <DownIcon />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  )
}
export default OrderTable
